import { format, isPast } from 'date-fns';

import { isEventStarted, countWonGames, isMatchFinished } from 'app/utils/match';

import type { MatchPreviewData, MatchPreviewTeam } from './types';

interface TeamMatchScore {
  value: string;
  type: 'win' | 'lose' | 'void' | 'draw';
}

function getBeginTime(beginAt: string): string {
  return format(new Date(beginAt), 'HH:mm');
}

function getBeginDate(beginAt: string): string {
  const matchDate = format(new Date(beginAt), 'MM/dd/yyyy');
  const today = format(new Date(), 'MM/dd/yyyy');

  if (matchDate === today) {
    return 'Today';
  }
  return format(new Date(beginAt), 'MM/dd');
}

function getScoreVariation(
  teamId: number,
  { draw, winner_id }: MatchPreviewData
): 'win' | 'lose' | 'void' | 'draw' {
  if (draw) {
    return 'draw';
  }
  if (winner_id === null) {
    return 'void';
  }
  if (winner_id === teamId) {
    return 'win';
  }
  return 'lose';
}

function getTeamsScores(
  match: MatchPreviewData,
  teamA: MatchPreviewTeam,
  teamB: MatchPreviewTeam
): [TeamMatchScore, TeamMatchScore] {
  if (isEventStarted(match) || match.game_advantage !== null) {
    const nbTeamAWin = countWonGames(teamA, match);
    const nbTeamBWin = countWonGames(teamB, match);

    const teamAValues: TeamMatchScore = {
      value: nbTeamAWin.toString(),
      type: getScoreVariation(teamA.id, match)
    };
    const teamBValues: TeamMatchScore = {
      value: nbTeamBWin.toString(),
      type: getScoreVariation(teamB.id, match)
    };

    if (match.game_advantage !== null && !isMatchFinished(match)) {
      teamAValues.type = 'void';
      teamBValues.type = 'void';
    }

    return [teamAValues, teamBValues];
  }

  // if match didn't start yet we display empty value
  const teamWithoutScore: TeamMatchScore = {
    value: '-',
    type: 'void'
  };
  return [teamWithoutScore, teamWithoutScore];
}

const shouldShowActions = (match: MatchPreviewData): boolean =>
  !isEventStarted(match) &&
  (match.end_at ? !isPast(new Date(match.end_at)) : true) &&
  match.status !== 'canceled';

export { getBeginTime, getBeginDate, getTeamsScores, shouldShowActions };
